// https://en.wikipedia.org/wiki/Email_address
import { parseOneAddress } from 'email-addresses';

// Use this regexp if the given string has 1 word. If the string has multiple words let say its a
// "phrase" then this regexp will check the entire phrase.
// This is regexp only useful for validating a single word in a string. E.g validating email in form.
//const singleEmailRegexp = /^([\w-_.]+@[^@]+[.][\w]{2,})$/;
export function isValidEmail(email: string) {
    const parsed = parseOneAddress({
        input: email,
        rfc6532: false,
        rejectTLD: true,
    });
    if (parsed?.type !== 'mailbox') {
        return false;
    }
    if (parsed.address.includes('%')) {
        return false;
    }
    return true;

    // return singleEmailRegexp.test(email);
}

// Use this regexp if you want the given string has multiple words on it like "phrase" or "statement". Useful
// for checking if there are emails in a given text.
// This function is more permissive than isValidEmail
//const multipleEmailRegexp = /([\w-.]+@[^@]+[.][\w]{2,})/g;
export function extractEmail(input: string): undefined | string | string[] {
    // Handle some special cases that passes as valid email addresses
    const string = input.replace(/^["%']*(.*?)["%']*$/, '$1');

    const parsed = parseOneAddress({
        input: string,
    });
    if (parsed?.type === 'group') {
        return parsed.addresses.map(({ address }) => address);
    }
    if (parsed?.type === 'mailbox') {
        return parsed.address;
    }
    return undefined;

    // // we use `match` in here so that we can extract the emails which are wrapped to any special characters.
    // const matches = string.match(multipleEmailRegexp) ?? [];
    // return matches.length > 0 ? matches[0] : undefined;
}
